import { useUserContext } from "./user-context";
import { Navigate, useLocation } from "@tanstack/react-router";

interface OrganizationGuardProps {
  children: React.ReactNode;
}

export function OrganizationGuard({ children }: OrganizationGuardProps) {
  const { isInitialized, isSwitchingOrganization, hasOrganizations, requiresTermsAcceptance } = useUserContext();
  const location = useLocation();

  const hasAddParam = location.search && typeof location.search === "object" && "add" in location.search && location.search.add === true;

  if (!isInitialized || isSwitchingOrganization) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600" />
      </div>
    );
  }

  const isTermsRoute = location.pathname === "/terms-acceptance";
  const isOnboardingRoute = location.pathname === "/onboarding";
  const isProfileRoute = location.pathname.startsWith("/profile");
  const isInvitationRoute = location.pathname.startsWith("/invitation/");
  const isOrganizationsRoute = location.pathname === "/organizations" || location.pathname === "/organizations/";

  if (requiresTermsAcceptance && !isTermsRoute && !isProfileRoute) {
    return <Navigate to="/terms-acceptance" />;
  }

  if (!hasOrganizations && !isOnboardingRoute && !isProfileRoute && !isInvitationRoute && !isOrganizationsRoute && !isTermsRoute) {
    return <Navigate to="/onboarding" search={{ add: false }} />;
  }

  // Allow access to onboarding with ?add=true to create/join additional orgs
  if (hasOrganizations && isOnboardingRoute && !hasAddParam) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
}